/* tslint:disable */
var TSelections = (function () {
    //for regularSelection
    var regularPickLine =
    {
        create: function (mode, selection, context) {
            if (selection.BetTypeID == 1) { return this.createRegularMLPickLine(mode, selection, context); }
            if (selection.BetTypeID == 2) { return this.createRegularHCPickLine(mode, selection, context); }
            return this.createRegularOUPickLine(mode, selection, context);
        },

        createRegularMLPickLine: function (mode, selection, context) {
            var __html = '';
            __html += `<strong data-uat="bet-slip-selection-name">${Selections.getRegularMLBetSide(selection)}</strong>`;
            //createRegularMLPickLinePoints
            if (Selections.showRegularMLPickLinePoints(selection)) {
                var points = Selections.getPickLinePoints(mode, selection, context);
                var updated = BetSlipStyles.getPointsUpdatedClassInBetSlipSelection(mode, selection);
                __html += `
                    <span id="cPoints_${selection.ViewKey}" class="${updated}" data-uat="bet-slip-selection-points">
                        (${Odds.formatPoints(points)})
                    </span>`;
            }
            return __html;
        },

        createRegularHCPickLine: function (mode, selection, context) {
            var __html = '';
            __html += `
                <strong class="${addCustomClass('event-details-team-name-hightlight', Bets.isFavoriteHighlightingEnabled() && selection.IsFavTeam)}" data-uat="bet-slip-selection-name">${Selections.getRegularHCBetSide(selection)}</strong>`;
                //createRegularHCPickLinePoints
                if (Selections.showRegularPickLinePoints(mode, selection, context) || Selections.showRegularHCPickLinePoints(selection)) {
                    var points = Selections.getPickLinePoints(mode, selection, context),
                    updated = BetSlipStyles.getPointsUpdatedClassInBetSlipSelection(mode, selection); __html += `
                        <span id="cPoints_${selection.ViewKey}" class="${updated}" data-uat="bet-slip-selection-points">${Odds.formatPoints(points)}</span>`;
                }

            return __html;
        },

        createRegularOUPickLine: function (mode, selection, context) {
            var __html = '';
            __html += `<strong data-uat="bet-slip-selection-name">${Selections.getRegularOUBetSide(selection)}</strong>`;
            //createRegularOUPickLinePoints
            if (Selections.showRegularPickLinePoints(mode, selection, context)) {
                var points = Selections.getPickLinePoints(mode, selection, context),
                    isOver = selection.BetSide == 1,
                    isUnder = selection.BetSide == 3,
                    updated = BetSlipStyles.getPointsUpdatedClassInBetSlipSelection(mode, selection);

                __html += `<span id="cPoints_${selection.ViewKey}" class="${updated}" data-uat="bet-slip-selection-points">${Odds.formatPoints(points, isOver, isUnder)}</span>`;
            }

            return __html;
        }
    };

    var regularSelection =
    {
        buildPick: function (mode, selection, context) {
            return regularPickLine.create(mode, selection, context);
        },

        buildDescription: function (mode, selection, context) {
            var tsSelection = Selections.teamSwapSelection(selection),
                team1Name = Selections.getFullPickLineValue(selection, tsSelection.Team1Name),
                team2Name = Selections.getFullPickLineValue(selection, tsSelection.Team2Name),
                lineEventTypeName = Selections.getLineEventTypeName(selection);
            var __html = ''; __html += `
                <div class="teams_desc" data-uat="bet-slip-event-name">
                    ${TSlipShared.createMasterEventDescription(selection, team1Name, team2Name)}
                    <span class="team_desc_virtual">${TSlipShared.createVirtualSportsDescription(selection)}</span>
                </div>
                <div class="event_desc" data-uat="bet-slip-bet-type">                    
                    ${TSlipShared.createBetTypeRow(lineEventTypeName, selection, tsSelection, mode)}
                </div>`;
                if (currentBettingViewID === CONSTANTS.BettingView.Asian && selection.LeagueName) { __html += `
                    <div class="event_league emphasis" data-uat="bet-slip-bet-league">
                        ${selection.LeagueName}
                    </div>`;
                }
            return __html;
        }
    };

    var QASelection =
    {
        buildPick: function (mode, selection, context) {
            return `<strong data-uat="bet-slip-selection-name">${Selections.getQAPickLine(selection)}</strong>`;
        },

        buildDescription: function (mode, selection, context) {
            var tsSelection = Selections.teamSwapQASelection(selection);
            var team1Name = Selections.getFullPickLineValue(selection, tsSelection.Team1Name);
            var team2Name = Selections.getFullPickLineValue(selection, tsSelection.Team2Name);
            var lineEventTypeName = Selections.getQALineEventTypeName(selection, team1Name, team2Name);
            var showEWString = context.isPurchase || (!Modes.isSingleMode(mode) && !IsUKBetSlip);
            var selectionEachWayIncluded = BetSlipUtil.getSelectionEachWayIncluded(selection, context);

            var __html = '';
            if (selection.MasterEventID) { __html += `
                <div class="teams_desc" data-uat="bet-slip-event-name">
                    ${TSlipShared.createMasterEventDescription(selection, team1Name, team2Name)}
                </div>`;
            } else {
                // createOutrightQADescription
                __html += `<strong class="qa_outright_desc" data-uat="bet-slip-event-name">${Selections.getOutrightQADescription(selection)}</strong>`;
            }

            if (BetSlipUtil.isVirtualSport(selection.BranchID)) {
                __html += `
                <div class="teams_desc" data-uat="bet-slip-event-name">
                    ${TSlipShared.createVirtualSportsDescription(selection)}
                </div>`;
            } __html += `
            <div class="event_desc" data-uat="bet-slip-bet-type">`;
            if (selection.LiveGroupID && selection.EventTypeID === 8) {
                __html += this.createEventDescriptionForLiveQASelection(selection);
            } else {
                __html += TSlipShared.createBetTypeRow(lineEventTypeName, selection, tsSelection, mode);
            } __html += `
            </div>`;
            if (currentBettingViewID === CONSTANTS.BettingView.Asian && selection.LeagueName) { __html += `
                <div class="event_league emphasis" data-uat="bet-slip-bet-league">
                    ${selection.LeagueName}
                </div>`;
            }
            if (selectionEachWayIncluded && showEWString) { __html += `
                <div class="betSlipEachWay" data-uat="bet-slip-each-way">
                    <strong class="betSlipEachWay__title" data-uat="bet-slip-each-way-label">
                        <small>${Selections.getEachWayString(selection)}</small>
                    </strong>
                </div>`;
            }

            return __html;
        },

        createEventDescriptionForLiveQASelection: function (selection) {
            return `${$string("General").LiveBetting}`;
        }
    };

    var multiLineSelection =
    {
        buildPick: function (mode, selection, context, selections) {
            var __html = ''; 
            for (var idx in selection.Selections) {
                var result = selection.getQASlipSelectionNameToPosition(idx, $dict.bs, selections);
                if (!result) {
                    continue;
                }

                __html += `
                    <div class="betSlipMultiPick__item">
                        <span class="pickLinePosition">${result.Position}</span> ${result.QASlipSelection.LineName}
                    </div>
                `;
            }

            return __html;
        },

        buildDescription: function (mode, selection, context, selections) {
            var qaSlipSelection = selection.getQASlipSelection(selections);

            if (!qaSlipSelection) {
                return '';
            }

            var betName = selection.getBetName($dict.bs);
            return `
                <div class="betSlip_row_desc">
                    <div>
                        ${qaSlipSelection.LeagueName}
                        ${selection.getEventTime()}
                    </div>
                    <div>
                        ${betName}
                    </div>
                </div>
            `;
        }
    };

    return {
        regularSelection: regularSelection,
        QASelection: QASelection,
        multiLineSelection: multiLineSelection
    };
}());

window.TSelections = TSelections;